

function article_1() {
	return {
		date: "Oct 8, 2024",
		title: "Delivery Route Optimization using Genetic Algorithms",
		description:
			"Explore how genetic algorithms can be used for optimizing delivery routes, inspired by a course on Foundations of Artificial Intelligence.",
		keywords: [
			"Delivery Route Optimization",
			"Genetic Algorithms",
			"Artificial Intelligence",
		],
		link : "https://medium.com/@vishwajeethogale307/delivery-route-optimization-using-genetic-algorithms-bb1bed3a49c6",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`
	};
}

function article_2() {
	return {
		date: "Mar 2, 2024",
		title: "What is RAG (Retrieval Augmented Generation)?",
		description:
			"Learn about Retrieval Augmented Generation (RAG) and its relationship with large language models.",
		keywords: [
			"Retrieval Augmented Generation",
			"RAG",
			"Large Language Models",
		],
		link : "https://medium.com/@vishwajeethogale307/what-is-rag-retrieval-augmented-generation-9c11632d3c5a",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`
	};
}

function article_3() {
	return {
		date: "Feb 27, 2024",
		title: "All you need to know about Spark Dataframe API",
		description:
			"An overview of the Apache Spark DataFrame API, its structure, and its programming interface for data processing.",
		keywords: [
			"Spark DataFrame API",
			"Apache Spark",
			"Data Processing",
		],
		link : "https://medium.com/@vishwajeethogale307/all-you-need-to-know-about-spark-dataframe-api-ee01ee173f11",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
		 		`
	};
}

function article_4() {
	return {
		date: "Feb 20, 2024",
		title: "Spark Adaptive Query Execution",
		description:
			"Understand the features of Spark Adaptive Query Execution that enable query optimization.",
		keywords: [
			"Spark Adaptive Query Execution",
			"Query Optimization",
			"Apache Spark",
		],
		link : "https://medium.com/@vishwajeethogale307/spark-adaptive-query-execution-2f6193902a47",
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`
		
	};
}

const myArticles = [article_1, article_2, article_3, article_4];

export default myArticles;
